import { useEffect, useRef } from "react";

const AD_CLIENT = "ca-pub-8902099051011521";
const AD_SLOT = "5801358149";

type AdFormat = "horizontal" | "vertical" | "auto";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export function AdSenseSlot({ format = "horizontal" }: { format?: AdFormat }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // 광고 차단이나 스크립트 지연
    }
  }, []);

  return (
    <div className="fe-hero-adsense">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
